// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"cfe1ab80","462":"02cdc1c4","550":"6be17660","578":"cfe1ab80","610":"6be17660","885":"e1bbfc0f"}[chunkId] + ".chunk.css";
};